<fury-loading-indicator></fury-loading-indicator>
<fury-backdrop #backdrop="furyBackdrop"></fury-backdrop>
<!-- <fury-config-panel-toggle (openConfig)="openConfigPanel()"></fury-config-panel-toggle> -->

<!-- QUICKPANEL -->
<fury-sidebar
  #configPanel="furySidebar"
  [backdrop]="backdrop"
  [invisibleBackdrop]="true"
  position="right"
  >
  <fury-config-panel></fury-config-panel>
</fury-sidebar>
<!-- END QUICKPANEL -->

@if (appTheme.isSteel()) {
  <!-- STEEL SHELL: full-width header over the side nav (styles/steel, app/layout/steel) -->
  <div class="container main-body-container steel-shell">
    <app-steel-header (openQuickPanel)="openQuickPanel()"></app-steel-header>
    <app-steel-alert-banner></app-steel-alert-banner>

    <div class="steel-body">
      <app-steel-nav></app-steel-nav>

      <mat-sidenav-container class="main-mat-sidenav-container steel-main">
        <mat-sidenav
          [(opened)]="quickPanelOpen"
          mode="over"
          position="end"
          autoFocus="first-heading"
        >
          <app-steel-alerts-panel></app-steel-alerts-panel>
        </mat-sidenav>

        <mat-sidenav-content
          class="content-container"
          fxLayout="column"
        >
          <div
            [class.scroll-disabled]="scrollDisabled$ | async"
            cdkScrollable
            class="content"
            fxFlex="auto"
            fxLayout="column"
          >
            <div
              class="content-inner"
              fxFlex="auto"
            >
              <router-outlet></router-outlet>
            </div>
          </div>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </div>
  </div>
} @else {
  <div
    class="container main-body-container"
    fxLayout="column"
    >
    @if ((toolbarPosition$ | async) === 'above-fixed') {
      <ng-container *ngTemplateOutlet="toolbar"></ng-container>
    }

    <mat-sidenav-container
      autosize
      fxFlex
      class="main-mat-sidenav-container"
      >
      <!-- SIDENAV -->
      @if (sideNavigation$ | async) {
        <mat-sidenav
          (closedStart)="closeSidenav()"
          (openedStart)="openSidenav()"
          [mode]="sidenavMode$ | async"
          [opened]="sidenavOpen$ | async"
          class="fury-collapsable-sidenav"
          >
          <fury-sidenav
            [collapsed]="sidenavCollapsed$ | async"
            [expanded]="sidenavExpanded$ | async"
          ></fury-sidenav>
        </mat-sidenav>
      }
      <!-- END SIDENAV -->

      <mat-sidenav
        [(opened)]="quickPanelOpen"
        mode="over"
        position="end"
        >
        <fury-quickpanel></fury-quickpanel>
      </mat-sidenav>

      <mat-sidenav-content
        class="content-container"
        fxLayout="column"
        >
        @if ((toolbarPosition$ | async) === 'fixed') {
          <ng-container *ngTemplateOutlet="toolbar"></ng-container>
        }

        <!-- CONTENT -->
        <div
          [class.scroll-disabled]="scrollDisabled$ | async"
          cdkScrollable
          class="content"
          fxFlex="auto"
          fxLayout="column"
          >
          @if ((toolbarPosition$ | async) === 'static') {
            <ng-container *ngTemplateOutlet="toolbar"></ng-container>
          }

          <div
            class="content-inner"
            fxFlex="auto"
            >
            <router-outlet></router-outlet>
          </div>
        </div>
        <!-- END CONTENT -->
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
}

<ng-template #toolbar>
  <!-- TOOLBAR -->
  @if (toolbarVisible$ | async) {
    <fury-toolbar
      (openQuickPanel)="openQuickPanel()"
      [hasNavigation]="topNavigation$ | async"
      (openSidenav)="openSidenav()"
      fxFlex="none"
    ></fury-toolbar>
  }
  <!-- END TOOLBAR -->

  <!-- NAVIGATION -->
  @if (topNavigation$ | async) {
    <fury-navigation
      fxFlex="none"
    ></fury-navigation>
  }
  <!-- END NAVIGATION -->
</ng-template>
